import { StandardEvents } from '@shopify/events';

if (!customElements.get('hovermist-header')) {
  customElements.define('hovermist-header', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const ticker = this.querySelector('.hm-ticker');
      const toggle = this.querySelector('[data-ticker-toggle]');
      if (toggle && ticker) {
        const update = paused => {
          ticker.dataset.paused = String(paused);
          if (!paused) ticker.dataset.motion = 'full';
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.setAttribute('aria-label', paused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel);
          toggle.querySelector('[data-pause-symbol]').hidden = paused;
          toggle.querySelector('[data-play-symbol]').hidden = !paused;
        };
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionPreference = () => {
          ticker.dataset.motion = this.motionPreference.matches ? 'still' : 'full';
          update(this.motionPreference.matches);
        };
        this.onMotionPreference();
        this.motionPreference.addEventListener('change', this.onMotionPreference);
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          const paused = ticker.dataset.paused !== 'true';
          update(paused);
        }, options);
      }
      this.querySelector('[data-cart-drawer]')?.addEventListener('click', event => {
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (typeof drawer?.open !== 'function') return;
        event.preventDefault();
        drawer.open();
      }, options);
      document.addEventListener(StandardEvents.cartLinesUpdate, event => {
        event.promise?.then(({ cart, detail }) => {
          if (!this.isConnected || detail?.didError) return;
          const count = Array.isArray(detail?.items)
            ? detail.items.reduce((total, item) => total + item.quantity, 0)
            : cart?.totalQuantity;
          if (!Number.isFinite(count)) return;
          const link = this.querySelector('.hm-cart-link');
          const badge = link?.querySelector('[data-cart-count]');
          if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
          if (link) link.setAttribute('aria-label', link.dataset.cartLabel.replace('__count__', String(count)));
        }).catch(() => {});
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.motionPreference?.removeEventListener('change', this.onMotionPreference);
    }
  });
}
